export const KafLifeLogo = ({ className }) => {
  return (
    <svg
      className={className}
      width='283'
      height='312'
      viewBox='0 0 283 312'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M39.9513 306.371H43.5718L44.9301 303.015L135.502 79.2298C138.024 73.2489 140.426 66.8907 142.712 60.1577C145.289 67.5108 147.628 73.729 149.729 78.7987L238.267 302.973L239.609 306.371H243.263L266.621 306.371H274.579L271.602 298.991L154.611 8.99053L153.255 5.62881L149.63 5.62881L136.428 5.62881L132.831 5.62881L131.461 8.95468L12.0335 298.955L8.97921 306.371H17L39.9513 306.371Z'
        fill='#3ACDEE'
        stroke='#3ACDEE'
        stroke-width='10.7424'
      />
      <path
        d='M150.044 301.001L89.2566 177.336L150.044 248.036L210.461 156.466L267.146 70.553L208.595 185.777L150.044 301.001Z'
        fill='#FFE262'
      />
      <path
        d='M267.146 70.553L210.461 156.466M267.146 70.553L150.044 248.036L89.2566 177.336L150.044 301.001L208.595 185.777L267.146 70.553Z'
        stroke='#FFE262'
        stroke-width='10.7424'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};
export const KafLifeTextLogo = ({ className }) => {
  return (
    <svg
      width='180'
      height='51'
      viewBox='0 0 180 51'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M37.237 38.2177H37.6786L37.8443 37.8084L48.8925 10.5103C49.2001 9.78077 49.4932 9.0052 49.772 8.18389C50.0864 9.08082 50.3717 9.83931 50.6279 10.4577L61.4281 37.8032L61.5918 38.2177H62.0375H64.8867L65.8575 38.2177L65.4943 37.3174L51.2235 1.94238L51.0581 1.53231L50.6159 1.53231L49.0055 1.53231L48.5667 1.53231L48.3996 1.93801L33.8315 37.3131L33.4589 38.2177H34.4373L37.237 38.2177Z'
        fill='#3ACDEE'
        stroke='#3ACDEE'
        stroke-width='1.31039'
      />
      <path
        d='M50.6663 37.5623L43.2513 22.4773L50.6663 31.1015L58.0361 19.9316L64.9507 9.45166L57.8085 23.507L50.6663 37.5623Z'
        fill='#FFE262'
      />
      <path
        d='M64.9507 9.45166L58.0361 19.9316M64.9507 9.45166L50.6663 31.1015L43.2513 22.4773L50.6663 37.5623L57.8085 23.507L64.9507 9.45166Z'
        stroke='#FFE262'
        stroke-width='1.31039'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M103.077 10.5V39.9601H123.914V34.5137H109.555V10.5H103.077Z'
        fill='#FFE262'
      />
      <path
        d='M132.94 15.3275V10.5H127.081V15.3275H132.94ZM127.081 18.6284V39.9601H132.94V18.6284H127.081Z'
        fill='#FFE262'
      />
      <path
        d='M138.833 22.5481V39.9601H144.692V22.5481H148.735V18.6284H144.692V17.3493C144.692 16.469 144.857 15.8501 145.187 15.4925C145.545 15.1074 146.122 14.9149 146.92 14.9149C147.663 14.9149 148.378 14.9562 149.065 15.0387V10.665C148.57 10.6375 148.061 10.61 147.539 10.5825C147.016 10.5275 146.494 10.5 145.971 10.5C143.578 10.5 141.79 11.1052 140.607 12.3155C139.424 13.5258 138.833 15.0799 138.833 16.9779V18.6284H135.326V22.5481H138.833Z'
        fill='#FFE262'
      />
      <path
        d='M165.653 27.0043H156.121C156.149 26.5917 156.231 26.124 156.369 25.6014C156.534 25.0788 156.795 24.5836 157.153 24.116C157.538 23.6484 158.033 23.2633 158.638 22.9607C159.271 22.6306 160.055 22.4656 160.99 22.4656C162.42 22.4656 163.48 22.8507 164.167 23.6209C164.882 24.3911 165.378 25.5189 165.653 27.0043ZM156.121 30.7177H171.512C171.622 29.0673 171.484 27.4856 171.099 25.9728C170.714 24.4599 170.081 23.112 169.201 21.9292C168.348 20.7464 167.248 19.8112 165.9 19.1235C164.552 18.4083 162.971 18.0507 161.155 18.0507C159.532 18.0507 158.047 18.3395 156.699 18.9172C155.379 19.4948 154.237 20.2925 153.274 21.3103C152.312 22.3006 151.569 23.4834 151.046 24.8587C150.524 26.2341 150.262 27.7195 150.262 29.3149C150.262 30.9653 150.51 32.4782 151.005 33.8535C151.528 35.2289 152.257 36.4117 153.192 37.402C154.127 38.3922 155.269 39.1624 156.616 39.7126C157.964 40.2352 159.477 40.4965 161.155 40.4965C163.576 40.4965 165.639 39.9464 167.344 38.8461C169.05 37.7458 170.315 35.9166 171.14 33.3584H165.983C165.79 34.0186 165.267 34.6512 164.415 35.2564C163.562 35.834 162.544 36.1229 161.361 36.1229C159.711 36.1229 158.446 35.6965 157.565 34.8438C156.685 33.9911 156.204 32.6157 156.121 30.7177Z'
        fill='#FFE262'
      />
      <path
        d='M103.077 10.5V39.9601H123.914V34.5137H109.555V10.5H103.077Z'
        stroke='#FFE262'
        stroke-width='1.1875'
      />
      <path
        d='M132.94 15.3275V10.5H127.081V15.3275H132.94ZM127.081 18.6284V39.9601H132.94V18.6284H127.081Z'
        stroke='#FFE262'
        stroke-width='1.1875'
      />
      <path
        d='M138.833 22.5481V39.9601H144.692V22.5481H148.735V18.6284H144.692V17.3493C144.692 16.469 144.857 15.8501 145.187 15.4925C145.545 15.1074 146.122 14.9149 146.92 14.9149C147.663 14.9149 148.378 14.9562 149.065 15.0387V10.665C148.57 10.6375 148.061 10.61 147.539 10.5825C147.016 10.5275 146.494 10.5 145.971 10.5C143.578 10.5 141.79 11.1052 140.607 12.3155C139.424 13.5258 138.833 15.0799 138.833 16.9779V18.6284H135.326V22.5481H138.833Z'
        stroke='#FFE262'
        stroke-width='1.1875'
      />
      <path
        d='M165.653 27.0043H156.121C156.149 26.5917 156.231 26.124 156.369 25.6014C156.534 25.0788 156.795 24.5836 157.153 24.116C157.538 23.6484 158.033 23.2633 158.638 22.9607C159.271 22.6306 160.055 22.4656 160.99 22.4656C162.42 22.4656 163.48 22.8507 164.167 23.6209C164.882 24.3911 165.378 25.5189 165.653 27.0043ZM156.121 30.7177H171.512C171.622 29.0673 171.484 27.4856 171.099 25.9728C170.714 24.4599 170.081 23.112 169.201 21.9292C168.348 20.7464 167.248 19.8112 165.9 19.1235C164.552 18.4083 162.971 18.0507 161.155 18.0507C159.532 18.0507 158.047 18.3395 156.699 18.9172C155.379 19.4948 154.237 20.2925 153.274 21.3103C152.312 22.3006 151.569 23.4834 151.046 24.8587C150.524 26.2341 150.262 27.7195 150.262 29.3149C150.262 30.9653 150.51 32.4782 151.005 33.8535C151.528 35.2289 152.257 36.4117 153.192 37.402C154.127 38.3922 155.269 39.1624 156.616 39.7126C157.964 40.2352 159.477 40.4965 161.155 40.4965C163.576 40.4965 165.639 39.9464 167.344 38.8461C169.05 37.7458 170.315 35.9166 171.14 33.3584H165.983C165.79 34.0186 165.267 34.6512 164.415 35.2564C163.562 35.834 162.544 36.1229 161.361 36.1229C159.711 36.1229 158.446 35.6965 157.565 34.8438C156.685 33.9911 156.204 32.6157 156.121 30.7177Z'
        stroke='#FFE262'
        stroke-width='1.1875'
      />
      <path
        d='M2.37482 9.31274V39H8.89007V29.4369L12.6249 25.6532L21.5471 39H29.7223L17.0238 21.038L28.6018 9.31274H20.4681L8.89007 21.6201V9.31274H2.37482Z'
        fill='#3B4F5A'
      />
      <path
        d='M71.7928 9.31247V38.9998H78.308V26.734H90.7159V21.6614H78.308V14.8009H92.6248V9.31247H71.7928Z'
        fill='#3B4F5A'
      />
    </svg>
  );
};
export const KafPayLogo = ({ className }) => {
  return (
    <svg
      className={className}
      width='156'
      height='44'
      viewBox='0 0 156 44'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M150.636 1C149.695 1 148.774 1.27922 147.991 1.80235C147.208 2.32548 146.598 3.06902 146.238 3.93896C145.877 4.80889 145.783 5.76614 145.967 6.68966C146.151 7.61317 146.604 8.46148 147.27 9.12729C147.936 9.79311 148.784 10.2465 149.707 10.4302C150.631 10.6139 151.588 10.5197 152.458 10.1593C153.328 9.79898 154.072 9.18877 154.595 8.40585C155.118 7.62293 155.397 6.70247 155.397 5.76086C155.397 4.4982 154.895 3.28726 154.003 2.39442C153.11 1.50159 151.899 1 150.636 1V1ZM150.636 9.56955C149.883 9.56955 149.147 9.34617 148.52 8.92767C147.894 8.50916 147.406 7.91433 147.117 7.21838C146.829 6.52243 146.754 5.75663 146.901 5.01782C147.048 4.27901 147.41 3.60036 147.943 3.06771C148.476 2.53506 149.154 2.17231 149.893 2.02535C150.632 1.8784 151.398 1.95382 152.094 2.24209C152.79 2.53036 153.385 3.01853 153.803 3.64487C154.222 4.2712 154.445 5.00757 154.445 5.76086C154.445 6.77099 154.044 7.73974 153.329 8.45401C152.615 9.16828 151.646 9.56955 150.636 9.56955V9.56955Z'
        fill='white'
      />
      <path
        d='M152.541 4.80869C152.541 4.42989 152.391 4.06661 152.123 3.79876C151.855 3.53091 151.492 3.38043 151.113 3.38043L148.732 3.38043V8.14129L149.684 8.14129V6.23695L150.38 6.23695L151.651 8.14129L152.793 8.14129L151.484 6.17982C151.786 6.09851 152.053 5.92033 152.244 5.67264C152.435 5.42494 152.539 5.12143 152.541 4.80869V4.80869ZM151.113 5.28478L149.684 5.28478V4.3326L151.113 4.3326C151.239 4.3326 151.36 4.38276 151.449 4.47205C151.539 4.56133 151.589 4.68242 151.589 4.80869C151.589 4.93496 151.539 5.05605 151.449 5.14533C151.36 5.23462 151.239 5.28478 151.113 5.28478Z'
        fill='white'
      />
      <path
        d='M17.8794 34.3566H18.9328L18.3125 33.5052L8.45491 19.9771L18.0008 10.1285L18.8816 9.21976L17.6161 9.21976L15.4762 9.21976H15.2475L15.0893 9.38486L5.66145 19.2241L3.91355 20.972L3.91355 9.75555L3.91355 9.21976H3.37776L1.69879 9.21976H1.163L1.163 9.75555L1.163 33.8208L1.163 34.3566H1.69879H3.37776H3.91355L3.91355 33.8208L3.91355 24.1863L6.50031 21.9047L15.3884 34.1357L15.5489 34.3566H15.8219H17.8794Z'
        fill='white'
        stroke='white'
        stroke-width='1.07159'
      />
      <path
        d='M60.2426 34.3562H60.7784V33.8204L60.7784 23.6075L71.1065 23.6075H71.6423V23.0717L71.6423 21.508V20.9722H71.1065L60.7784 20.9722L60.7784 11.8383L71.7485 11.8383H72.2843V11.3025V9.75519V9.21939H71.7485L58.5637 9.21939H58.0279V9.75519L58.0279 33.8204V34.3562H58.5637H60.2426Z'
        fill='white'
        stroke='white'
        stroke-width='1.07159'
      />
      <path
        d='M27.0063 34.4591H27.4041L27.5533 34.0904L37.5038 9.50456C37.7808 8.84749 38.0448 8.14895 38.296 7.40923C38.579 8.21704 38.836 8.90018 39.0668 9.45714L48.794 34.0858L48.9414 34.4591H49.3428L51.9089 34.4591H52.7833L52.4562 33.6482L39.6032 1.78784L39.4542 1.41851L39.056 1.41851L37.6055 1.41851L37.2104 1.41851L37.0599 1.7839L23.9392 33.6443L23.6036 34.4591H24.4848L27.0063 34.4591Z'
        fill='#0791AF'
        stroke='#0791AF'
        stroke-width='1.18019'
      />
      <path
        d='M39.1015 33.8691L32.4232 20.2828L39.1015 28.0502L45.7391 17.99L51.9667 8.55133L45.5341 21.2102L39.1015 33.8691Z'
        fill='#00B147'
      />
      <path
        d='M51.9667 8.55133L45.7391 17.99M51.9667 8.55133L39.1015 28.0502L32.4232 20.2828L39.1015 33.8691L45.5341 21.2102L51.9667 8.55133Z'
        stroke='#00B147'
        stroke-width='1.18019'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M103.558 16.3669C103.558 19.0434 102.642 21.1051 100.809 22.5518C98.9885 23.9866 96.3783 24.7039 92.9784 24.7039L89.8678 24.7039L89.8678 35.1025H86.7935L86.7935 8.6629L93.6475 8.6629C100.254 8.6629 103.558 11.2309 103.558 16.3669ZM89.8678 22.0636L92.6348 22.0636C95.3595 22.0636 97.3307 21.6235 98.5484 20.7434C99.7661 19.8633 100.375 18.4527 100.375 16.5116C100.375 14.7634 99.8023 13.4613 98.6569 12.6053C97.5116 11.7493 95.7272 11.3213 93.3039 11.3213L89.8678 11.3213L89.8678 22.0636Z'
        fill='white'
      />
      <path
        d='M120.847 35.1025L120.25 32.2813H120.105C119.117 33.5231 118.128 34.3671 117.139 34.8132C116.163 35.2472 114.939 35.4642 113.468 35.4642C111.503 35.4642 109.96 34.9579 108.839 33.9451C107.729 32.9324 107.175 31.4916 107.175 29.6229C107.175 25.6202 110.376 23.5224 116.778 23.3295L120.141 23.221V21.9912C120.141 20.436 119.804 19.2906 119.129 18.5552C118.466 17.8077 117.399 17.4339 115.928 17.4339C114.276 17.4339 112.407 17.9403 110.321 18.953L109.399 16.6563C110.376 16.1258 111.443 15.7099 112.6 15.4084C113.77 15.107 114.939 14.9563 116.109 14.9563C118.472 14.9563 120.22 15.4808 121.353 16.5297C122.498 17.5786 123.071 19.2605 123.071 21.5753L123.071 35.1025L120.847 35.1025ZM114.065 32.9866C115.934 32.9866 117.399 32.4742 118.46 31.4495C119.533 30.4247 120.069 28.99 120.069 27.1453V25.355L117.067 25.4815C114.68 25.5659 112.956 25.9397 111.895 26.6028C110.846 27.2538 110.321 28.2726 110.321 29.6591C110.321 30.7442 110.647 31.57 111.298 32.1367C111.961 32.7033 112.883 32.9866 114.065 32.9866Z'
        fill='white'
      />
      <path
        d='M126.127 15.2819L129.346 15.2819L133.687 26.5847C134.639 29.1648 135.23 31.0275 135.459 32.1728H135.604C135.76 31.558 136.086 30.5091 136.58 29.0261C137.087 27.5311 138.726 22.9497 141.499 15.2819L144.718 15.2819L136.2 37.8514C135.357 40.0818 134.368 41.6612 133.235 42.5895C132.113 43.5299 130.733 44.0001 129.093 44.0001C128.177 44.0001 127.273 43.8977 126.381 43.6927V41.2875C127.044 41.4321 127.785 41.5045 128.605 41.5045C130.667 41.5045 132.137 40.3471 133.018 38.0322L134.121 35.211L126.127 15.2819Z'
        fill='white'
      />
    </svg>
  );
};

export const BackArrowIcon = ({ className, onClick = () => {} }) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      width='48'
      height='46'
      viewBox='0 0 48 46'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97918 12.6066 1.3934C12.0208 0.807609 11.0711 0.807609 10.4853 1.3934L0.93934 10.9393ZM48 10.5L2 10.5L2 13.5L48 13.5L48 10.5Z'
        fill='white'
      />
      <path
        d='M13.9806 39.302V36.124H16.6406C16.9299 36.124 17.2006 36.1427 17.4526 36.18C17.7139 36.208 17.9426 36.278 18.1386 36.39C18.3346 36.502 18.4886 36.6607 18.6006 36.866C18.7126 37.0713 18.7686 37.3513 18.7686 37.706C18.7686 38.238 18.6006 38.6393 18.2646 38.91C17.9379 39.1713 17.3966 39.302 16.6406 39.302H13.9806ZM12.6506 35.004V45H17.4806C17.9753 45 18.4093 44.9207 18.7826 44.762C19.1653 44.594 19.4826 44.3793 19.7346 44.118C19.9959 43.8473 20.1919 43.5393 20.3226 43.194C20.4533 42.8487 20.5186 42.494 20.5186 42.13C20.5186 41.514 20.3553 40.9913 20.0286 40.562C19.7019 40.1327 19.2306 39.8527 18.6146 39.722V39.694C19.0906 39.5073 19.4546 39.2227 19.7066 38.84C19.9679 38.448 20.0986 37.986 20.0986 37.454C20.0986 36.95 19.9819 36.5253 19.7486 36.18C19.5246 35.8347 19.2493 35.564 18.9226 35.368C18.7733 35.2747 18.5913 35.2047 18.3766 35.158C18.1713 35.1113 17.9473 35.0787 17.7046 35.06C17.4619 35.032 17.2146 35.018 16.9626 35.018C16.7199 35.0087 16.4913 35.004 16.2766 35.004H12.6506ZM13.9806 43.88V40.422H17.0186C17.2986 40.422 17.5693 40.45 17.8306 40.506C18.0919 40.5527 18.3206 40.6413 18.5166 40.772C18.7219 40.8933 18.8853 41.0613 19.0066 41.276C19.1279 41.4907 19.1886 41.7613 19.1886 42.088C19.1886 42.648 19.0206 43.0867 18.6846 43.404C18.3579 43.7213 17.9006 43.88 17.3126 43.88H13.9806ZM28.4506 44.972C28.2452 45.0933 27.9606 45.154 27.5966 45.154C27.2886 45.154 27.0412 45.07 26.8546 44.902C26.6772 44.7247 26.5886 44.44 26.5886 44.048C26.2619 44.44 25.8792 44.7247 25.4406 44.902C25.0112 45.07 24.5446 45.154 24.0406 45.154C23.7139 45.154 23.4012 45.1167 23.1026 45.042C22.8132 44.9673 22.5612 44.8507 22.3466 44.692C22.1319 44.5333 21.9592 44.328 21.8286 44.076C21.7072 43.8147 21.6466 43.502 21.6466 43.138C21.6466 42.7273 21.7166 42.3913 21.8566 42.13C21.9966 41.8687 22.1786 41.6587 22.4026 41.5C22.6359 41.332 22.8972 41.206 23.1866 41.122C23.4852 41.038 23.7886 40.968 24.0966 40.912C24.4232 40.8467 24.7312 40.8 25.0206 40.772C25.3192 40.7347 25.5806 40.688 25.8046 40.632C26.0286 40.5667 26.2059 40.478 26.3366 40.366C26.4672 40.2447 26.5326 40.072 26.5326 39.848C26.5326 39.5867 26.4812 39.3767 26.3786 39.218C26.2852 39.0593 26.1592 38.938 26.0006 38.854C25.8512 38.77 25.6786 38.714 25.4826 38.686C25.2959 38.658 25.1092 38.644 24.9226 38.644C24.4186 38.644 23.9986 38.742 23.6626 38.938C23.3266 39.1247 23.1446 39.484 23.1166 40.016H21.9266C21.9452 39.568 22.0386 39.19 22.2066 38.882C22.3746 38.574 22.5986 38.3267 22.8786 38.14C23.1586 37.944 23.4759 37.804 23.8306 37.72C24.1946 37.636 24.5819 37.594 24.9926 37.594C25.3192 37.594 25.6412 37.6173 25.9586 37.664C26.2852 37.7107 26.5792 37.8087 26.8406 37.958C27.1019 38.098 27.3119 38.2987 27.4706 38.56C27.6292 38.8213 27.7086 39.162 27.7086 39.582V43.306C27.7086 43.586 27.7226 43.7913 27.7506 43.922C27.7879 44.0527 27.8999 44.118 28.0866 44.118C28.1892 44.118 28.3106 44.0947 28.4506 44.048V44.972ZM26.5186 41.262C26.3692 41.374 26.1732 41.458 25.9306 41.514C25.6879 41.5607 25.4312 41.6027 25.1606 41.64C24.8992 41.668 24.6332 41.7053 24.3626 41.752C24.0919 41.7893 23.8492 41.8547 23.6346 41.948C23.4199 42.0413 23.2426 42.1767 23.1026 42.354C22.9719 42.522 22.9066 42.7553 22.9066 43.054C22.9066 43.25 22.9439 43.418 23.0186 43.558C23.1026 43.6887 23.2052 43.796 23.3266 43.88C23.4572 43.964 23.6066 44.0247 23.7746 44.062C23.9426 44.0993 24.1199 44.118 24.3066 44.118C24.6986 44.118 25.0346 44.0667 25.3146 43.964C25.5946 43.852 25.8232 43.7167 26.0006 43.558C26.1779 43.39 26.3086 43.2127 26.3926 43.026C26.4766 42.83 26.5186 42.648 26.5186 42.48V41.262ZM34.4721 40.086H35.7041C35.6574 39.6567 35.5454 39.288 35.3681 38.98C35.1908 38.6627 34.9621 38.4013 34.6821 38.196C34.4114 37.9907 34.0941 37.8413 33.7301 37.748C33.3754 37.6453 32.9928 37.594 32.5821 37.594C32.0128 37.594 31.5134 37.6967 31.0841 37.902C30.6548 38.098 30.2954 38.3733 30.0061 38.728C29.7261 39.0733 29.5161 39.484 29.3761 39.96C29.2361 40.4267 29.1661 40.9307 29.1661 41.472C29.1661 42.0133 29.2361 42.5127 29.3761 42.97C29.5254 43.418 29.7401 43.8053 30.0201 44.132C30.3094 44.4587 30.6641 44.7107 31.0841 44.888C31.5134 45.0653 32.0034 45.154 32.5541 45.154C33.4781 45.154 34.2061 44.9113 34.7381 44.426C35.2794 43.9407 35.6154 43.25 35.7461 42.354H34.5281C34.4534 42.914 34.2481 43.348 33.9121 43.656C33.5854 43.964 33.1281 44.118 32.5401 44.118C32.1668 44.118 31.8448 44.0433 31.5741 43.894C31.3034 43.7447 31.0841 43.5487 30.9161 43.306C30.7481 43.054 30.6221 42.7693 30.5381 42.452C30.4634 42.1347 30.4261 41.808 30.4261 41.472C30.4261 41.108 30.4634 40.758 30.5381 40.422C30.6128 40.0767 30.7341 39.7733 30.9021 39.512C31.0794 39.2507 31.3128 39.0407 31.6021 38.882C31.8914 38.7233 32.2508 38.644 32.6801 38.644C33.1841 38.644 33.5854 38.77 33.8841 39.022C34.1828 39.274 34.3788 39.6287 34.4721 40.086ZM37.1476 35.004V45H38.3376V42.256L39.4576 41.22L41.9356 45H43.4476L40.3676 40.394L43.2376 37.762H41.6416L38.3376 40.926V35.004H37.1476Z'
        fill='white'
      />
    </svg>
  );
};

export const MailIcon = () => {
  return (
    <svg
      width='18'
      height='12'
      viewBox='0 0 18 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.88 0H15.13C16.38 0 17.01 0.59 17.01 1.79V10.21C17.01 11.4 16.38 12 15.13 12H1.88C0.63 12 0 11.4 0 10.21V1.79C0 0.59 0.63 0 1.88 0ZM8.5 8.6L15.24 3.07C15.48 2.87 15.67 2.41 15.37 2C15.08 1.59 14.55 1.58 14.2 1.83L8.5 5.69L2.81 1.83C2.46 1.58 1.93 1.59 1.64 2C1.34 2.41 1.53 2.87 1.77 3.07L8.5 8.6Z'
        fill='#A4AFB0'
      />
    </svg>
  );
};

export const PasswordIcon = () => {
  return (
    <svg
      width='17'
      height='19'
      viewBox='0 0 17 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.2273 8.36H14.5852V3.04C14.5852 1.36088 13.2016 0 11.4943 0H5.50568C3.79844 0 2.41477 1.36088 2.41477 3.04V8.36H0.772727C0.345312 8.36 0 8.69963 0 9.12V18.24C0 18.6604 0.345312 19 0.772727 19H16.2273C16.6547 19 17 18.6604 17 18.24V9.12C17 8.69963 16.6547 8.36 16.2273 8.36ZM9.17614 13.9887V15.2475C9.17614 15.352 9.0892 15.4375 8.98295 15.4375H8.01705C7.9108 15.4375 7.82386 15.352 7.82386 15.2475V13.9887C7.62453 13.848 7.47575 13.6487 7.39893 13.4194C7.32212 13.1902 7.32123 12.943 7.3964 12.7132C7.47157 12.4835 7.61892 12.2831 7.81724 12.141C8.01556 11.9989 8.25461 11.9223 8.5 11.9223C8.74539 11.9223 8.98444 11.9989 9.18276 12.141C9.38108 12.2831 9.52843 12.4835 9.6036 12.7132C9.67877 12.943 9.67788 13.1902 9.60106 13.4194C9.52425 13.6487 9.37547 13.848 9.17614 13.9887ZM12.8466 8.36H4.15341V3.04C4.15341 2.30612 4.75952 1.71 5.50568 1.71H11.4943C12.2405 1.71 12.8466 2.30612 12.8466 3.04V8.36Z'
        fill='#A4AFB0'
      />
    </svg>
  );
};

export const ToggleIcon = () => {
  return (
    <svg
      width='18'
      height='10'
      viewBox='0 0 18 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1 1L9 9L17 1'
        stroke='#A4AFB0'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export const Check = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <path d='M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z' />
    </svg>
  );
};

export const FlagTr = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='640'
      height='480'
      viewBox='0 0 640 480'
    >
      <g fill-rule='evenodd'>
        <path fill='#f31930' d='M0 0h640v480H0z' />
        <path
          fill='#fff'
          d='M406.977 247.473c0 66.215-54.606 119.89-121.97 119.89S163.04 313.686 163.04 247.472s54.606-119.89 121.968-119.89 121.97 53.677 121.97 119.89z'
        />
        <path
          fill='#f31830'
          d='M413.077 247.467c0 52.97-43.686 95.91-97.575 95.91s-97.574-42.94-97.574-95.91 43.686-95.91 97.574-95.91 97.575 42.94 97.575 95.91z'
        />
        <path
          fill='#fff'
          d='M430.726 191.465l-.985 44.318-41.345 11.225 40.756 14.514-.984 40.642 26.58-31.738 40.164 13.934-23.233-34.06 28.352-33.868-43.513 11.998-25.793-36.964z'
        />
      </g>
    </svg>
  );
};

export const FlagEn = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='640'
      height='480'
      viewBox='0 0 640 480'
    >
      <defs>
        <clipPath id='a'>
          <path fill-opacity='.67' d='M-85.333 0h682.67v512h-682.67z' />
        </clipPath>
      </defs>
      <g clip-path='url(#a)' transform='translate(80) scale(.94)'>
        <g stroke-width='1pt'>
          <path fill='#006' d='M-256 0H768.02v512.01H-256z' />
          <path
            fill='#fff'
            d='M-256 0v57.244l909.535 454.768H768.02V454.77L-141.515 0H-256zM768.02 0v57.243L-141.515 512.01H-256v-57.243L653.535 0H768.02z'
          />
          <path
            fill='#fff'
            d='M170.675 0v512.01h170.67V0h-170.67zM-256 170.67v170.67H768.02V170.67H-256z'
          />
          <path
            fill='#c00'
            d='M-256 204.804v102.402H768.02V204.804H-256zM204.81 0v512.01h102.4V0h-102.4zM-256 512.01L85.34 341.34h76.324l-341.34 170.67H-256zM-256 0L85.34 170.67H9.016L-256 38.164V0zm606.356 170.67L691.696 0h76.324L426.68 170.67h-76.324zM768.02 512.01L426.68 341.34h76.324L768.02 473.848v38.162z'
          />
        </g>
      </g>
    </svg>
  );
};

export const ArrowDown = ({ style }) => {
  return (
    <svg
      width='18'
      height='10'
      viewBox='0 0 18 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
    >
      <path
        d='M1 1L9 9L17 1'
        stroke='#A4AFB0'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};
export const PhoneIcon = () => {
  return (
    <svg
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.3438 2.54297L13.2637 0.464844C13.1169 0.317468 12.9425 0.200535 12.7505 0.120763C12.5584 0.0409902 12.3525 -4.9843e-05 12.1445 4.54287e-08C11.7207 4.54287e-08 11.3223 0.166016 11.0234 0.464844L8.78516 2.70312C8.63778 2.84986 8.52085 3.02426 8.44108 3.21632C8.3613 3.40837 8.32026 3.6143 8.32031 3.82227C8.32031 4.24609 8.48633 4.64453 8.78516 4.94336L10.4219 6.58008C10.0388 7.42453 9.5061 8.19275 8.84961 8.84766C8.19477 9.50574 7.42662 10.0403 6.58203 10.4258L4.94531 8.78906C4.79858 8.64169 4.62418 8.52475 4.43212 8.44498C4.24006 8.36521 4.03414 8.32417 3.82617 8.32422C3.40234 8.32422 3.00391 8.49023 2.70508 8.78906L0.464845 11.0254C0.317288 11.1724 0.200255 11.3471 0.120478 11.5395C0.0407023 11.7319 -0.000242029 11.9382 1.07624e-06 12.1465C1.07624e-06 12.5703 0.166017 12.9688 0.464845 13.2676L2.54102 15.3438C3.01758 15.8223 3.67578 16.0938 4.35156 16.0938C4.49414 16.0938 4.63086 16.082 4.76563 16.0586C7.39844 15.625 10.0098 14.2246 12.1172 12.1191C14.2227 10.0156 15.6211 7.40625 16.0605 4.76562C16.1934 3.95898 15.9258 3.12891 15.3438 2.54297Z'
        fill='#A4AFB0'
      />
    </svg>
  );
};
